/*global Materialize*/
import React, { Component } from 'react';
import { fetch }            from  '@fyresite/fetch'
import queryString          from 'query-string'


class ActivateUser extends Component {

  constructor(props){
    super(props);
    this.state = {
      message: 'Please wait....'
    }
  }

  async componentDidMount(){
    const parsed = queryString.parse(this.props.location.search);
    let response = await fetch("/api/v1/user/activate", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: parsed.email,
        token: parsed.token
      }),
      credentials: process.env.NODE_ENV === 'production' ? 'same-origin' : 'include'
    }).then(result => {
      return result;
    }).catch(err => {
      return {status: 501, error: err, message: err.message}
    })

    if(response.status !== 501){
      let json = await response.json();
      if(json.code === 200){
        this.setState({
          message: json.message
        })
      } else {
        this.setState({
          message: json.result.errors
        })
      }

      Materialize.toast(json.message, 4000);

    } else {
      Materialize.toast(response.message, 4000);
    }

    this.props.history.push('/')
  }

  render() {
    return (
      <div> { this.state.message} </div>
    );
  }
}

export default ActivateUser;



// WEBPACK FOOTER //
// ./src/pages/Home/ActivateUser/ActivateUser.js